import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import {
  getAvailableGroupsKey,
  getAvailableGroups,
} from '../api-client/listing/get-available-groups'

export default function useAvailableGroups(benefitsProgramId) {
  const [availableGroups, setAvailableGroups] = useState({})

  useQuery({
    queryKey: [getAvailableGroupsKey + benefitsProgramId],
    queryFn: () => getAvailableGroups(benefitsProgramId),
    enabled: !!benefitsProgramId,
    onSuccess: (data) => {
      setAvailableGroups(data)
    },
  })

  return { availableGroups }
}
